import { render, staticRenderFns } from "./ConfirmMessage.vue?vue&type=template&id=0296b645&scoped=true"
import script from "./ConfirmMessage.vue?vue&type=script&lang=js"
export * from "./ConfirmMessage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMessage.vue?vue&type=style&index=0&id=0296b645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296b645",
  null
  
)

export default component.exports